import React from 'react';
import './StepByStepSection.scss';

import PropTypes from 'prop-types';

const StepByStepSection = ({ data }) => {
  if (!data || !data.step_by_step_instructions) return null;

  return (
    <section className="StepByStep_Container">
      <div className="StepByStep_title">{data.bottom_heading}</div>

      <div className="PartnerLayout_Steps">
        {data.step_by_step_instructions.map((item, idx) => (
          <div className="Step_Item" key={idx}>
            {typeof item === 'string' ? (
              <div className="Step_Text">{item}</div>
            ) : (
              <div className="Step_Image_Row">{item}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

StepByStepSection.propTypes = {
  data: PropTypes.shape({
    bottom_heading: PropTypes.string,
    step_by_step_instructions: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    ),
  }).isRequired,
};

export default StepByStepSection;
